var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"noDataBox"},[_c('svg-icon',{style:({fontSize:_vm.size}),attrs:{"icon-class":"noData"}}),_vm._v(" "),_c('h3',[_vm._v(_vm._s(_vm.title)),_vm._t("link")],2)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ../cache/node/node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3555a34b","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!../cache/node/node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/NoData/index.vue
// module id = null
// module chunks = 